import { connect, MapStateToProps } from "react-redux";

import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getInjectedComponentOnRender, ReplaceableComponentNames } from "../../customization/internalIndex";
import { isSearchActive } from "../../search";
import { QuickAccessMenuComponentProps } from "../QuickAccessMenuComponent";

const mapStateToProps: MapStateToProps<QuickAccessMenuComponentProps, NoneOwnProps, IAppState> = (state) => ({
    isSearchActive: isSearchActive(state),
});

export const QuickAccessMenu = connect(mapStateToProps)(getInjectedComponentOnRender(ReplaceableComponentNames.QuickAccessMenuComponent));
